"use strict";
import { __exports as d } from "./index.es311.js";
import { __require as I } from "./index.es312.js";
import { __require as v } from "./index.es313.js";
import { __require as O } from "./index.es314.js";
import { __require as b } from "./index.es305.js";
import { __require as z } from "./index.es315.js";
var K;
function F() {
  return K ? d : (K = 1, (function(x) {
    Object.defineProperty(x, "__esModule", {
      value: !0
    });
    function N(i, t) {
      for (var r in t) Object.defineProperty(i, r, {
        enumerable: !0,
        get: t[r]
      });
    }
    N(x, {
      getNamedMiddlewareRegex: function() {
        return q;
      },
      getNamedRouteRegex: function() {
        return k;
      },
      getRouteRegex: function() {
        return E;
      }
    });
    const _ = I(), h = v(), p = O(), P = b(), g = z();
    function y(i, t, r) {
      const s = {};
      let o = 1;
      const n = [];
      for (const c of (0, P.removeTrailingSlash)(i).slice(1).split("/")) {
        const u = h.INTERCEPTION_ROUTE_MARKERS.find((f) => c.startsWith(f)), a = c.match(g.PARAMETER_PATTERN);
        if (u && a && a[2]) {
          const { key: f, optional: e, repeat: l } = (0, g.parseMatchedParameter)(a[2]);
          s[f] = {
            pos: o++,
            repeat: l,
            optional: e
          }, n.push("/" + (0, p.escapeStringRegexp)(u) + "([^/]+?)");
        } else if (a && a[2]) {
          const { key: f, repeat: e, optional: l } = (0, g.parseMatchedParameter)(a[2]);
          s[f] = {
            pos: o++,
            repeat: e,
            optional: l
          }, r && a[1] && n.push("/" + (0, p.escapeStringRegexp)(a[1]));
          let R = e ? l ? "(?:/(.+?))?" : "/(.+?)" : "/([^/]+?)";
          r && a[1] && (R = R.substring(1)), n.push(R);
        } else
          n.push("/" + (0, p.escapeStringRegexp)(c));
        t && a && a[3] && n.push((0, p.escapeStringRegexp)(a[3]));
      }
      return {
        parameterizedRoute: n.join(""),
        groups: s
      };
    }
    function E(i, t) {
      let { includeSuffix: r = !1, includePrefix: s = !1, excludeOptionalTrailingSlash: o = !1 } = t === void 0 ? {} : t;
      const { parameterizedRoute: n, groups: c } = y(i, r, s);
      let u = n;
      return o || (u += "(?:/)?"), {
        re: new RegExp("^" + u + "$"),
        groups: c
      };
    }
    function A() {
      let i = 0;
      return () => {
        let t = "", r = ++i;
        for (; r > 0; )
          t += String.fromCharCode(97 + (r - 1) % 26), r = Math.floor((r - 1) / 26);
        return t;
      };
    }
    function S(i) {
      let { interceptionMarker: t, getSafeRouteKey: r, segment: s, routeKeys: o, keyPrefix: n, backreferenceDuplicateKeys: c } = i;
      const { key: u, optional: a, repeat: f } = (0, g.parseMatchedParameter)(s);
      let e = u.replace(/\W/g, "");
      n && (e = "" + n + e);
      let l = !1;
      (e.length === 0 || e.length > 30) && (l = !0), isNaN(parseInt(e.slice(0, 1))) || (l = !0), l && (e = r());
      const R = e in o;
      n ? o[e] = "" + n + u : o[e] = u;
      const M = t ? (0, p.escapeStringRegexp)(t) : "";
      let m;
      return R && c ? m = "\\k<" + e + ">" : f ? m = "(?<" + e + ">.+?)" : m = "(?<" + e + ">[^/]+?)", a ? "(?:/" + M + m + ")?" : "/" + M + m;
    }
    function T(i, t, r, s, o) {
      const n = A(), c = {}, u = [];
      for (const a of (0, P.removeTrailingSlash)(i).slice(1).split("/")) {
        const f = h.INTERCEPTION_ROUTE_MARKERS.some((l) => a.startsWith(l)), e = a.match(g.PARAMETER_PATTERN);
        if (f && e && e[2])
          u.push(S({
            getSafeRouteKey: n,
            interceptionMarker: e[1],
            segment: e[2],
            routeKeys: c,
            keyPrefix: t ? _.NEXT_INTERCEPTION_MARKER_PREFIX : void 0,
            backreferenceDuplicateKeys: o
          }));
        else if (e && e[2]) {
          s && e[1] && u.push("/" + (0, p.escapeStringRegexp)(e[1]));
          let l = S({
            getSafeRouteKey: n,
            segment: e[2],
            routeKeys: c,
            keyPrefix: t ? _.NEXT_QUERY_PARAM_PREFIX : void 0,
            backreferenceDuplicateKeys: o
          });
          s && e[1] && (l = l.substring(1)), u.push(l);
        } else
          u.push("/" + (0, p.escapeStringRegexp)(a));
        r && e && e[3] && u.push((0, p.escapeStringRegexp)(e[3]));
      }
      return {
        namedParameterizedRoute: u.join(""),
        routeKeys: c
      };
    }
    function k(i, t) {
      var r, s, o;
      const n = T(i, t.prefixRouteKeys, (r = t.includeSuffix) != null ? r : !1, (s = t.includePrefix) != null ? s : !1, (o = t.backreferenceDuplicateKeys) != null ? o : !1);
      let c = n.namedParameterizedRoute;
      return t.excludeOptionalTrailingSlash || (c += "(?:/)?"), {
        ...E(i, t),
        namedRegex: "^" + c + "$",
        routeKeys: n.routeKeys
      };
    }
    function q(i, t) {
      const { parameterizedRoute: r } = y(i, !1, !1), { catchAll: s = !0 } = t;
      if (r === "/")
        return {
          namedRegex: "^/" + (s ? ".*" : "") + "$"
        };
      const { namedParameterizedRoute: o } = T(i, !1, !1, !1, !1);
      let n = s ? "(?:(/.*)?)" : "";
      return {
        namedRegex: "^" + o + n + "$"
      };
    }
  })(d), d);
}
export {
  F as __require
};
//# sourceMappingURL=index.es278.js.map
